module.exports = __webpack_public_path__ + "static/media/client_snapshot.7a7a580b.svg";